export default {
  seeUnarchivedCampaigns: 'See unarchived campaigns',
  seeArchivedCampaigns: 'See archived campaigns',
  sendMassSms: 'Send out mass SMS',
  mustChargeBeforeSendingCampaigns: 'You must charge money before sending out campaigns',
  sendSmsCampaignFromFile: 'Send out SMS campaign from file',
  createCampaign: 'Create campaign',
  sendCampaignToDirectory: 'Send campaign to your people directory',
  forms: 'Forms',
  unArchive: 'Unarchive',
  archive: 'Archive',
  loadingCampaigns: 'Loading campaigns',
  noCampaignsCreated: 'You haven\'t created any campaign',
  type: 'Type',
  status: 'Status',
  campaignSuccessfullyArchived: 'Campaign successfully archived',
  sendCampaign: 'Send campaign',
  shippingDateAndTime: 'Shipping date and time',
  scheduleCampaign: 'Schedule campaign',
  campaignReadyAndWaitingToBeSent: 'Your campaign is ready and waiting to be sent',
  schedule: 'Schedule',
  export: 'Export',
  campaignStatus: 'Campaign status',
  campaignScope: 'Campaign scope',
  messagesToBeSent: 'Messages to be sent',
  thisValueCouldChange: 'This value could change',
  finalValue: 'Final value',
  sendingDate: 'Sending date',
  campaignProgress: 'Campaign progress',
  moreCounters: 'More counters',
  lessCounters: 'Less counters',
  importingPeopleProgress: 'Progress in importing people',
  importedPeople: 'Imported people',
  peopleAmount: 'People amount',
  importingErrors: 'Importing errors',
  sending: 'Sending',
  sent: 'Sent | Sent | Sent',
  onStandBy: 'On standby',
  onDraft: 'On draft',
  scheduled: 'Scheduled',
  all: 'All',
  pending: 'Pending',
  deliveredToCarrier: 'Delivered to carrier',
  rejected: 'Rejected | Rejected',
  postponed: 'Postponed | Postponed',
  hardRebound: 'Hard rebound | Hard rebounds',
  softRebound: 'Soft rebound | Soft rebounds',
  opened: 'Opened | Opened',
  inSpam: 'In spam',
  terminated: 'Terminated | Terminated',
  inBlackList: 'In black list',
  inWhiteList: 'In white list',
  messagePart: 'Message part | Message parts',
  delivered: 'Delivered',
  importMorePeople: 'Import more people',
  loadingUsers: 'Loading users',
  clicked: 'Clicked',
  multiParts: 'Multi parts',
  seeMessage: 'See message',
  noUserDefinedMessage: 'This user doesn\'t have a defined message',
  youAreSeeingTheMessageOf: 'You are seeing the message of',
  nameOfTheMassSms: 'Name of the mass SMS',
  insertMassSmsKeyName: 'Insert an SMS key name that helps you remembering what was this SMS about',
  noFilePicked: 'You haven\'t picked any file',
  downloadFormat: 'Download format',
  prepareMassSms: 'Prepare mass SMS',
  insertMassSmsName: 'Insert the name of the mass SMS',
  mustPickSmsFile: 'You must pick an SMS file',
  campaignSuccessfullyCreated: 'Campaign successfully created',
  campaignName: 'Campaign\'s name',
  insertMassCampaignKeyName: 'Insert a campaign key name that helps you remembering what was this campaign about',
  campaignType: 'Campaign type',
  pickCampaignType: 'Pick a campaign type',
  writeYourMessageHere: 'Write your message here...',
  pickPeopleList: 'Pick a list of people',
  pickOrCreateListOfPeopleToCommunicateMessage: 'Pick the list of people who you want to communicate your message or create a new list importing it from an external file',
  pickOrCreateTemplate: 'Pick templates or create a new one',
  pickTemplate: 'Pick your template',
  allPeople: 'All people',
  waitWhileTheListGetsCreated: 'Wait while the list get\'s created',
  noPeopleListPicked: 'You haven\'t picked any list of people',
  addYourFirstCondition: 'Add your first condition',
  addAnotherCondition: 'Add another condition',
  attributeCondition: 'Attribute condition',
  actionCondition: 'Action condition',
  segmentPeopleByAttributesAndActions: 'You can segment the people who interact with your company, either by their attributes, or by actions performed within your platform.',
  youAreAlmostDone: '¡You are almost done!',
  yourMessageScope: 'Your message is going to reach {numberOfPeople} people',
  prepareCampaign: 'Prepare campaign',
  draft: 'Save',
  template: 'Template',
  insertMessageSubject: 'Insert message subject',
  insertMessageHtml: 'Insert message html',
  createHtmlTemplate: 'Create your template',
  importPeople: 'Import people',
  insertCampaignName: 'Insert campaign\'s name',
  insertCampaignType: 'Insert campaign\'s type',
  subject: 'Subject',
  templates: 'Templates',
  allTemplates: 'All templates',
  insertHtmlTemplate: 'Create template',
  previewTemplate: 'Preview template',
  customize: 'Customize',
  from: 'From',
  to: 'To',
  until: 'Until',
  attribute: 'Attribute',
  contains: 'Contains',
  noContains: 'Not contains',
  is: 'is',
  isNot: 'is not',
  addANameToYourTemplate: 'Add a name to your template',
  templateName: 'Template name',
  save: 'Save',
  /* triggers */
  triggers: 'Triggers',
  noTitle: 'No title',
  loadingTriggers: 'Loading triggers',
  noRegisteredTriggers: 'There aren\'t registered triggers',
  title: 'Title',
  executeTriggerWhenActionFire: 'Execute trigger when action get\'s fired',
  customActionToFilter: 'Custom action to filter',
  actionsToExecute: 'Actions to execute',
  emailBody: 'Email\'s body',
  smsBody: 'SMS\'s body',
  postRequestData: 'POST request data',
  saveTrigger: 'Save trigger',
  trigger: 'Trigger',
  new: 'New',
  edit: 'Edit',
  add: 'Add',
  triggerDetails: 'Trigger details',
  triggerScope: 'Trigger\'s scope',
  editTrigger: 'Edit trigger',
  createTrigger: 'Create trigger',
  triggerSuccessfullyCreated: 'Trigger successfully created',
  triggerSuccessfullyUpdated: 'Trigger successfully updated',
  launchers: 'Launchers',
  actionType: '{action} action',
  addNotification: 'Add notification',
  notifications: 'Notifications',
  loadingNotifications: 'Loading notifications',
  noNotificationsCreated: 'There aren\'t notifications created',
  newNotification: 'New notification',
  notificationCreatedSuccessfully: 'Notification created successfully',
  editNotification: 'Edit notification',
  notificationEditedSuccessfully: 'Notification edited successfully',
  youDontHaveNotifications: 'You don\'t have notifications',
  invalidFileType: 'Invalid file type',
  noDataFound: 'No data found',
  clickOnYourFileTypeOrDragHere: 'Click on your file type or drag here',
  filesSize: 'Files larger than 5 Mbs and videos than 16 mb are not supported',
  findQuickAnswer: 'Find Quick Answer',
  noAnswerFound: 'We can\'t find the answer you\'re looking for',
  titleNewInformation: 'Title of the new information',
  waitingForAttention: 'Waiting for attention',
  terminationReason: 'Termination reason',
  findTerminationReason: 'Find termination reason',
  nameless: 'Nameless',
  conversationClassification: 'Conversation classification',
  withoutAdvisor: 'Without advisor',
  you: 'You',
  agents: 'Agents',
  advisors: 'Advisors',
  conversations: 'Conversations',
  host: 'Host',
  attended: 'Attended',
  noAttended: 'No attended',
  responseTime: 'Duration of the conversation',
  noAttendedConversations: 'No attended conversations',
  attendedConversations: 'Attended conversations',
  totalConversations: 'Total conversations',
  lastMonth: 'Last Month',
  phone: 'Phone',
  organic: 'Organic',
  conversationsPerChannel: 'Conversations per channel',
  createdPeople: 'Created people',
  waitTime: 'Wait Time',
  yesterday: 'Yesterday',
  withBot: 'With bot',
  assignTaskAfterSettingJourney: 'Assign task after setting journey',
  pickAJourneyStatus: 'Pick a journey status',
  journeys: 'Journeys',
  timeInMinutesToCreateTaskAfterSettingJourney: 'Time in minutes to create task after setting the Journey',
  untrainedQuestions: 'Untrained questions',
  numberOfQuestions: 'Number of questions',
  serviceRating: 'Service rating',
  usersWhoGotProactivity: 'Users who got proactivity',
  bot: 'Bot',
  questions: 'Questions',
  operator: 'Operador',
  time: 'Time',
  attendedAndUnansweredConversations: 'Attended and unanswered conversations',
  total: 'Total',
  pickExtraData: 'Pick extra data',
  pickExtraDataFieldAndValue: 'Pick extra data field and value',
  writeExtraDataValue: 'Write extra data value',
  termsAndConditions: 'Terms and Conditions',
  showTermsAndConditionsOfUse: 'Show terms and conditions of use',
  termsAndConditionsLink: 'Terms and conditions link',
  campaignInformation: 'Campaign information',
  // Trigger to do list translations
  smsToUser: 'SMS to user',
  emailToUser: 'Email to user',
  postRequestToServer: 'Post request to server',
  createTaskForUser: 'Create task for user',
  // Trigger action types translations
  ACTION_CUSTOM: 'Custom action',
  ACTION_REGISTER_EMAIL: 'On email register',
  ACTION_REGISTER_PHONE: 'On phone register',
  ACTION_REGISTER_VERIFIED: 'On register verified',
  ACTION_REGISTER_EMAIL_RESEND: 'On resending register email',
  ACTION_REGISTER_SOCIAL: 'On register with social networks',
  ACTION_REGISTER_GOOGLE: 'On register with Google',
  ACTION_REGISTER_FACEBOOK: 'On register with Facebook',
  ACTION_REGISTER_SPOTIFY: 'On register with Spotify',
  ACTION_REGISTER_INSTAGRAM: 'On register with Instagram',
  ACTION_REGISTER_APPLEID: 'On register with AppleId',
  ACTION_REGISTER_EMAIL_FAIL: 'On register with email fails',
  ACTION_REGISTER_PHONE_FAIL: 'On register with phone fails',
  ACTION_LOGIN_EMAIL: 'On email login',
  ACTION_LOGIN_PHONE: 'On phone login',
  ACTION_LOGIN_SOCIAL: 'On login with social networks',
  ACTION_LOGIN_GOOGLE: 'On login with Google',
  ACTION_LOGIN_FACEBOOK: 'On login with Facebook',
  ACTION_LOGIN_INSTAGRAM: 'On login with Instagram',
  ACTION_LOGIN_SPOTIFY: 'On login with Spotify',
  ACTION_LOGIN_APPLEID: 'On login with AppleId',
  ACTION_LOGIN_MAIL_ONE_TIME_PASSWORD: 'On login with email and one time password',
  ACTION_LOGIN_MAIL_ONE_TIME_PASSWORD_FAIL: 'On login with email and one time password fails',
  ACTION_LOGIN_PHONE_ONE_TIME_PASSWORD: 'On login with phone and one time password',
  ACTION_LOGIN_PHONE_ONE_TIME_PASSWORD_FAIL: 'On login with phone and one time password fails',
  ACTION_LOGIN_EMAIL_FAIL: 'On email login fails',
  ACTION_LOGIN_EMAIL_FAIL_USER: 'On administrator email login fails',
  ACTION_LOGIN_EMAIL_FAIL_AUTHS: 'On email login fails in authentication',
  ACTION_LOGIN_EMAIL_FAIL_WRONG_PSW: 'On email login fails by wrong password',
  ACTION_LOGIN_PHONE_FAIL: 'On phone login fails',
  ACTION_LOGIN_PHONE_FAIL_USER: 'On administrator phone login fails',
  ACTION_LOGIN_PHONE_FAIL_AUTHS: 'On phone login fails in authentication',
  ACTION_LOGIN_PHONE_FAIL_WRONG_PSW: 'On phone login fails by wrong password',
  ACTION_RESET_PASSWORD_PHONE: 'On reset password with phone',
  ACTION_RESET_PASSWORD_EMAIL: 'On reset password with email',
  ACTION_RESET_VALIDATION: 'On reset validation',
  ACTION_RESET_OTP: 'On reset otp',
  ACTION_LOGOUT: 'On logout',
  ACTION_SUBMIT: 'On form submit',
  ACTION_SUBMIT_FILE: 'On form file submit',
  ACTION_USER_IMAGE: 'On user image changes',
  ACTION_EVENT_PURCHASE: 'On event ticket purchase',
  ACTION_EVENT_PURCHASE_CONFIRMATION: 'On event ticket purchase confirmation',
  ACTION_USER_CHANGE: 'On administrator info changes',
  ACTION_ON_JOURNEY_SET: 'On Journey set',
  ACTION_ON_EXTRADATA_FIELD_CHANGE: 'On extra data field changes',
  ACTION_ON_EXTRADATA_VALUE_CHANGE: 'On extra data value changes',
  attachFiles: 'Attach files',
  attachFilesInCampaignDescription: `
  In order to attach files to your Email campaign,
  each file that you attach can only weight 5mb and the total size of the files
  must weight less than {size} {units}.
  `,
  sizeOfFileCantExceed: 'The size of each file can\'t exceed {size} {units}',
  filesTotalSizeMustBeSmallerThan: 'The total size of your files can\'t exceed {size} {units}',
  attachedFiles: 'Attached files',
  fileSuccessfullyDeleted: 'File deleted successfully',
  fileWithSameNameAlreadyExists: 'A file with the same name already exists',
  filesSuccessfullyAttached: 'File successfully attached'
}
